import { createAction, props } from '@ngrx/store';
import { Program } from 'src/generated/graphql';

export const programsSearch = createAction(
  '[Program] programs search',
  props<{ searchTerm: string }>()
);
export const programsSearchSuccess = createAction(
  '[Program] programs search success',
  props<{ programs: Program[] }>()
);
